import {
  AirplaneTiltIcon,
  LightningIcon,
  PackageIcon,
  TruckIcon,
  type Icon,
} from '@phosphor-icons/react';

export type FulfillmentTypeAppearance = {
  icon: Icon;
  /** Tints the disc the icon sits in. */
  className: string;
};

const NEUTRAL = 'sk:bg-fill-secondary sk:text-fg-secondary';

/*
 * A warehouse names its own speeds, so these are read rather than looked up:
 * the fastest tier first, because "priority overnight" is both.
 */
const TIERS: { match: RegExp; appearance: FulfillmentTypeAppearance }[] = [
  {
    match: /overnight|next[\s-]?day|one[\s-]?day|1[\s-]?day|priority|urgent/i,
    appearance: {
      icon: LightningIcon,
      className: 'sk:bg-warning-bg sk:text-warning',
    },
  },
  {
    match: /expedit|express|second[\s-]?day|two[\s-]?day|2[\s-]?day|air|fast/i,
    appearance: {
      icon: AirplaneTiltIcon,
      className: 'sk:bg-info-bg sk:text-info',
    },
  },
  {
    match: /standard|ground|economy|saver|surface|freight|slow/i,
    appearance: { icon: TruckIcon, className: NEUTRAL },
  },
];

/** The face a fulfillment speed wears: faster reads warmer. */
export function fulfillmentTypeAppearance(
  value: string,
): FulfillmentTypeAppearance {
  return (
    TIERS.find(tier => tier.match.test(value || ''))?.appearance || {
      icon: PackageIcon,
      className: NEUTRAL,
    }
  );
}
